module.exports = {"150202001":"和平街道","150202002":"财神庙街道","150202003":"西脑包街道","150202004":"南门外街道","150202005":"南圪洞街道","150202006":"东站街道","150202007":"回民街道","150202008":"天骄街道","150202009":"河东街道","150202010":"铁西街道","150202011":"东兴街道","150202012":"杨圪楞街道","150202100":"河东镇","150202101":"沙尔沁镇","150202198":"县级单位直辖村级单位（特殊镇）","150202400":"铝业工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150202.json
// module id = 402
// module chunks = 0